/**
 * CherryBlossomEffect.jsx
 * Animated cherry blossom petals for spring
 */
import React, { useEffect, useState } from 'react';

const CherryBlossomEffect = ({ intensity = 'medium', enabled = true }) => {
  const [petals, setPetals] = useState([]);

  const intensityConfig = {
    light: 20,
    medium: 40,
    heavy: 70
  };

  const petalColors = [
    '#FFB7C5', // Light pink
    '#FF69B4', // Hot pink
    '#FFC0CB', // Pink
    '#FFD1DC', // Pastel pink
    '#FADADD', // Pale pink
  ];

  const count = intensityConfig[intensity] || intensityConfig.medium;

  useEffect(() => {
    if (!enabled) {
      setPetals([]);
      return;
    }

    const blossoms = Array.from({ length: count }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      color: petalColors[Math.floor(Math.random() * petalColors.length)],
      animationDuration: Math.random() * 6 + 8,
      animationDelay: Math.random() * 8,
      size: Math.random() * 10 + 6,
      rotation: Math.random() * 360,
      swayDirection: Math.random() > 0.5 ? 1 : -1
    }));

    setPetals(blossoms);
  }, [enabled, intensity, count]);

  if (!enabled) return null;

  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden z-[1]">
      <style>{`
        @keyframes petalFall {
          0% {
            transform: translateY(-20px) translateX(0) rotate(0deg);
            opacity: 0;
          }
          10% {
            opacity: 1;
          }
          25% {
            transform: translateY(25vh) translateX(40px) rotate(90deg);
          }
          50% {
            transform: translateY(50vh) translateX(-30px) rotate(180deg);
          }
          75% {
            transform: translateY(75vh) translateX(50px) rotate(270deg);
          }
          90% {
            opacity: 0.8;
          }
          100% {
            transform: translateY(100vh) translateX(20px) rotate(360deg);
            opacity: 0;
          }
        }
        
        .petal {
          position: absolute;
          top: -20px;
          border-radius: 50% 0 50% 0;
          animation: petalFall ease-in-out infinite;
          box-shadow: 0 0 3px rgba(255, 182, 193, 0.5);
        }
      `}</style>
      
      {petals.map(petal => (
        <div
          key={petal.id}
          className="petal"
          style={{
            left: `${petal.left}%`,
            width: `${petal.size}px`,
            height: `${petal.size * 0.7}px`,
            backgroundColor: petal.color,
            animationDuration: `${petal.animationDuration}s`,
            animationDelay: `${petal.animationDelay}s`,
            transform: `rotate(${petal.rotation}deg)`
          }}
        />
      ))}
    </div>
  );
};

export default CherryBlossomEffect;
